<template>
  <div>
    <el-button 
        v-if="!flag"
        type="primary"
        :disabled="!routeId"
        style="margin-bottom: 10px"
        @click="$refs.partsModal.open()">
      添加
    </el-button>
    <div class="productRoute">
      <div class="treeMenu">
        <el-tree
            ref="areaTrees"
            :data="treeData"
            node-key="key"
            :props="treeProps"
            highlight-current
            default-expand-all
            :expand-on-click-node="false"
            @current-change="currentChange"/>
      </div>
      <div class="treeNodeContent">
        <el-table
            :data="tableData"
            row-key="scanIndex"
            class="dragTable"
            border
            style="width: 100%">
          <el-table-column type="index" width="55" align="center" label="#"/>
          <el-table-column prop="processNo" align="center" label="工序编号" width="100"/>
          <el-table-column prop="processName" align="center" label="工序名称" width="120"/>
          <el-table-column align="center" label="工作单元" width="180">
            <template v-slot="scope">
              <el-input v-model="scope.row.workUnitName" placeholder="请选择工作单元">
                <el-button slot="append" icon="el-icon-search" @click="workUnitSelectOpen(scope.row)"/>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="partsNo" align="left" label="部件编号" width="150"/>
          <el-table-column prop="partsName" align="left" label="部件名称" min-width="380"/>
          <el-table-column prop="isMainSn" align="center" label="主条码" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.isMainSn">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column prop="isUniqueSn" align="center" label="唯一码" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.isUniqueSn">唯一码</span>
              <span v-else>自制条码</span>
            </template>
          </el-table-column>
          <el-table-column prop="fixedWorkingTime" align="center" label="固定工时" width="80"/>
          <el-table-column prop="variableWorkingTime" align="center" label="变动工时" width="80"/>
          <el-table-column
              v-if="!flag"
              label="操作"
              align="center"
              width="80"
              fixed="right">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.isMainSn" type="danger" @click="deleteRow(scope.row)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 添加扫描部件 -->
    <parts-edit ref="partsModal" @partsSave="addParts"/>
    <work-unit-select ref="workUnitSelect" @select="workUnitSelect"/>
  </div>
</template>

<script>
  import PartsEdit from "./PartsEdit";
  import Sortable from "sortablejs";
  import WorkUnitSelect from "@/views/information/WorkUnit/WorkUnitSelect";
  export default {
    components: {
      PartsEdit,
      WorkUnitSelect,
    },

    props: {
      treeData: {
        type: Array,
        default: function() {
          return [];
        },
      },

      // 产品工艺信息标准数据(原始数据)
      originTableData: {
        type: Array,
        default: function() {
          return [];
        },
      },

      routeId: {
        type: String,
        default: "",
      },
      flag: {
        type:Boolean,
        default:false,
      },
    },

    data() {
      return {
        index:"",
        treeProps: {
          label: "title",
        },
        tableData: [],
        finalTableData: [], // 产品工艺信息最终提交的数据
      };
    },

    watch: {
      treeData: {
        immediate: true,
        handler(val) {
          if (val.length) {
            this.$nextTick(() => {
              this.$refs.areaTrees.setCurrentKey(this.treeData[0].key);
              this.treeCurrentSelect = this.treeData[0];
              const result = this.originTableData.filter((item) => item.processNo === this.treeCurrentSelect.processNo && item.processIndex === this.treeCurrentSelect.processIndex);
              this.tableData = result;
            });
          }
        },
      },
      originTableData: {
        immediate: true,
        handler(val) {
          if (val.length) {
            this.finalTableData = val;
          } else {
            this.tableData = val;
            this.finalTableData = val;
          }
        },
      },
    },

    mounted() {
      this.$nextTick(() => {
        this.rowDrop();
      });
    },

    methods: {
      // 删除扫描信息
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.tableData = this.tableData.filter((item) => item.key !== row.key);
          this.finalTableData = this.finalTableData.filter((item) => item.key !== row.key);
          // 重置"扫描序号"
          const newArr = this.treeCurrentSelect.children.filter((item) => item.key !== row.key);
          newArr.forEach((item, index) => {
            item.title = "扫描序号" + (index + 1);
          });
          this.treeCurrentSelect.children = newArr;
          this.$emit("updateSuccess", this.finalTableData);
        });
      },

      // 选中树形菜单查询扫描信息
      currentChange(data) {
        if ("children" in data) {
          this.treeCurrentSelect = data;
          const result = this.finalTableData.filter((item) => item.processNo === this.treeCurrentSelect.processNo && item.processIndex === this.treeCurrentSelect.processIndex);
          this.tableData = result;
        }
      },

      // 添加扫描部件
      addParts(data) {
        const maxKey = Math.max.apply(
          Math,
          this.finalTableData.map((item) => {
            return item.key;
          })
        );
        const maxScanIndex = Math.max.apply(
          Math,
          this.finalTableData.map((item) => {
            return item.scanIndex;
          })
        );
        const obj = {
          key: maxKey + 1,
          partsNo: data.partsNo,
          partsName: data.partsName,
          isMainSn: false,
          isUniqueSn: data.isUniqueSn,
          processNo: this.treeCurrentSelect.processNo,
          processName: this.treeCurrentSelect.title,
          fixedWorkingTime: data.fixedWorkingTime,
          variableWorkingTime: data.variableWorkingTime,
          processId: this.treeCurrentSelect.processId,
          processIndex: this.treeCurrentSelect.processIndex,
          scanIndex: maxScanIndex + 1,
        };
        this.tableData.push(obj);
        this.finalTableData.push(obj);
        const treeObj = {
          key: maxKey + 1,
          title: "扫描序号" + (+this.treeCurrentSelect.children.length + 1),
        };
        this.treeCurrentSelect.children.push(treeObj);
        this.$emit("updateSuccess", this.finalTableData);
      },

      //行拖拽
      rowDrop() {
        const tbody = document.querySelector(".dragTable .el-table__body-wrapper tbody");
        const that = this;
        Sortable.create(tbody, {
          onEnd({ newIndex, oldIndex }) {
            const currRow = that.tableData.splice(oldIndex, 1)[0]; //当前拖拽行
            if (newIndex === 0 || oldIndex === 0) {
              that.tableData.splice(oldIndex, 0, currRow);
            } else {
              that.tableData.splice(newIndex, 0, currRow);
            }
            const newList = that.tableData.slice(0);
            that.tableData = [];
            that.tableData = newList.map((item) => item.scanIndex);
            that.$nextTick(() => {
              that.tableData = newList;
              let finalArr = [];
              that.finalTableData.forEach((item) => {
                if (item.processIndex === currRow.processIndex && item.processNo === currRow.processNo) {
                } else {
                  finalArr.push(item);
                }
              });
              that.finalTableData = finalArr.concat(that.tableData);
              that.$emit("updateSuccess", that.finalTableData);
            });
            // 禁止拖动主条码
            if (newIndex === 0 || oldIndex === 0) {
              that.$message.warning("禁止拖动主条码");
            }
          },
        });
      },

      workUnitSelectOpen(row) {
        this.$refs.workUnitSelect.open(row.processId);
      },

      //工序选择
      workUnitSelect(row) {
        this.tableData.workUnitName = row.workUnitName;
        this.tableData.workUnitId = row.pkId;
        this.finalTableData.forEach(item=>{
          if(item.processNo === this.treeCurrentSelect.processNo) {
            item.workUnitName = row.workUnitName;
            item.workUnitId = row.pkId;
          }
        });
        this.rowDrop();
        this.$emit("updateSuccess", this.finalTableData);
      },
    },
  };
</script>

<style scoped>
.productRoute {
  width: 100%;
  display: flex;
  min-height: 240px;
}

.productRoute .treeMenu {
  width: 160px;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 10px;
  box-sizing: border-box;
  margin-right: 10px;
}

.productRoute .treeNodeContent {
  width: calc(100% - 160px);
  min-height: 240px;
}
</style>

<style>
.productRoute .el-tree-node__content {
  padding-left: 0px !important;
}
</style>
